export default __webpack_public_path__ + "static/media/img-9.c68a3880.png";